import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {
    FormBuilder,
    FormGroup,
    ReactiveFormsModule,
    Validators,
} from '@angular/forms';
import { NgIf } from '@angular/common';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { CustomizerSettingsService } from '../../customizer-settings/customizer-settings.service';
import { AuthService } from '../../core/auth/auth.service';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
    selector: 'app-mfa-login',
    standalone: true,
    imports: [
        RouterLink,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        ReactiveFormsModule,
        NgIf,
        TranslocoModule,
    ],
    templateUrl: './mfa-login.component.html',
    styleUrl: './mfa-login.component.scss',
})
export class MfaLoginComponent {
    // isToggled
    isToggled = false;

    // Form
    authForm: FormGroup;

    // Show alert
    showAlert: boolean = false;

    constructor(
        private fb: FormBuilder,
        private router: Router,
        public themeService: CustomizerSettingsService,
        private authService: AuthService
    ) {
        this.authForm = this.fb.group({
            token: [
                '',
                [
                    Validators.required,
                    Validators.minLength(6),
                    Validators.maxLength(6),
                ],
            ],
        });
        this.themeService.isToggled$.subscribe((isToggled) => {
            this.isToggled = isToggled;
        });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * On submit
     */
    onSubmit(): void {
        // Return if the form is invalid
        if (this.authForm.invalid) {
            this.showAlert = false;
            return;
        }

        // Disable the form
        this.authForm.disable();

        // Hide the alert
        this.showAlert = false;

        // Sign in
        this.authService.mfaSignIn(this.authForm.value).subscribe({
            next: (value) => {
                // Navigate to the redirect url
                this.router.navigateByUrl('/dashboard');
            },
            error: (error) => {
                let errMsg: string = error;

                // Show the alert
                this.showAlert = true;

                // Re-enable the form
                this.authForm.enable();

            },
            complete: () => {

            },
        });
    }

    // Dark Mode
    toggleTheme() {
        this.themeService.toggleTheme();
    }

    // Card Border
    toggleCardBorderTheme() {
        this.themeService.toggleCardBorderTheme();
    }

    // RTL Mode
    toggleRTLEnabledTheme() {
        this.themeService.toggleRTLEnabledTheme();
    }

}
